import { render, staticRenderFns } from "./FileChip.vue?vue&type=template&id=43781c05&"
import script from "./FileChip.vue?vue&type=script&lang=js&"
export * from "./FileChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports